import React, { forwardRef } from 'react';
import { KTSVG } from '../../../../_metronic/helpers';

const Alert = forwardRef(
	(
		{
			Tostlist,
			setList,
			position,
			margin,
			modal,
			top,
			left,
			successAlert,
			width,
			setTimeOut,
			minWidth,
			className,
			onClose,
			close
		}: any,
		ref: any
	): any => {
		return (
			Tostlist &&
			Tostlist?.map((tost: any, index: any): any => {
				return (
					<div
						ref={ref}
						className={`${className} alert alert-responcive alert-dismissible ${successAlert
							? 'bg-light-success'
							: 'bg-light-danger'
							} border ${successAlert ? 'border-success' : 'border-danger'
							} d-flex justify-content-between align-items-center flex-sm-row p-5 mb-3 alert-position ${modal ? 'something' : ''
							}`}
						key={index}
						style={{
							position: position,
							zIndex: '9999',
							margin: margin,
							width: modal ? width ?? '650px' : '',
							top: top,
							left: left,
							minWidth: minWidth,
						}}
					>
						<div
							className={`d-flex ${successAlert ? 'text-success' : 'text-danger'
								}  pe-0 pe-sm-10`}
						>
							<span className="font-weight-bold d-flex align-items-center">
								{tost?.message}
							</span>
						</div>

						<button
							type="button"
							className="btn btn-icon "
							onClick={(e: any) => {
								e.preventDefault();
								if (close) {
									onClose();
								}
								setList([]);
								if (successAlert) {
									setTimeOut(false);
								}
							}}
						>
							<span className="svg-icon svg-icon-1 svg-icon-primary">
								{' '}
								<KTSVG
									path="/media/icons/duotune/arrows/closeicon.svg"
									className={`svg-icon-2 mt-4 ms-3 ${successAlert ? 'fill-color' : ''
										}`}
								/>
							</span>
						</button>
					</div>
				);
			})
		);
	}
);

export default Alert;
